import React from 'react';

const PackageCard = ({ package: pkg, onViewDetails }) => {
  return (
    <div className={`package-card rounded-2xl p-6 ${pkg.popular ? 'popular' : ''}`}>
      {/* Package Header */}
      <div className="flex justify-between items-start mb-6">
        <div>
          <div className="text-3xl font-bold text-blue-400 mb-1">{pkg.speed}</div>
          <div className="text-sm text-gray-400 mb-2">Kecepatan</div>
          <div className={`inline-block px-3 py-1 rounded-full text-xs font-bold text-white ${pkg.badgeColor}`}>
            {pkg.badge}
          </div>
        </div>
        {pkg.popular && (
          <div className="text-yellow-400 text-2xl">⭐</div>
        )}
      </div>

      {/* Package Info */}
      <div className="mb-6">
        <h3 className="text-xl font-bold mb-2">{pkg.name}</h3>
        <p className="text-gray-400 text-sm mb-4 leading-relaxed">{pkg.description}</p>
        
        {/* Price */}
        <div className="mb-4">
          <div className="flex items-baseline gap-2">
            <span className="text-2xl font-bold text-white">{pkg.price}</span>
            {pkg.originalPrice && (
              <>
                <span className="text-lg text-gray-500 line-through">{pkg.originalPrice}</span>
                <span className="bg-red-500 text-white px-2 py-1 rounded-full text-xs font-bold">
                  -{pkg.discount}
                </span>
              </>
            )}
          </div>
          <div className="text-sm text-gray-400">/bulan</div>
        </div>
      </div>

      {/* Features */}
      <div className="mb-6 space-y-3">
        {pkg.features.slice(0, 4).map((feature, i) => (
          <div key={i} className="flex items-center">
            <div className="feature-icon mr-3 text-white">
              {feature.icon}
            </div>
            <span className="text-sm text-gray-300">{feature.name}</span>
          </div>
        ))}
        {pkg.features.length > 4 && (
          <button 
            onClick={onViewDetails}
            className="text-blue-400 text-sm hover:text-blue-300"
          >
            +{pkg.features.length - 4} fitur lainnya
          </button>
        )}
      </div>

      {/* Action Buttons */}
      <div className="space-y-3">
        <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold transition-colors">
          Mulai Free Trial
        </button>
        <button 
          onClick={onViewDetails}
          className="w-full border border-gray-600 text-gray-300 hover:text-white hover:border-gray-500 py-2 rounded-xl font-medium transition-colors"
        >
          Lihat Detail
        </button>
      </div>

      {/* Ideal Uses */}
      <div className="mt-4 pt-4 border-t border-gray-700">
        <div className="text-xs text-gray-400 mb-2">Cocok untuk:</div>
        <div className="flex flex-wrap gap-1">
          {pkg.ideal.map((use, i) => (
            <span key={i} className="bg-gray-700 text-xs px-2 py-1 rounded-full text-gray-300">
              {use}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PackageCard;